import React, { useState, useRef, useEffect } from 'react';
import Input from '../../../../Components/Input';
import TextInput from '../../../../Components/TextInput';
import DateInput from '../../../../Components/DateInput';
import search from '../../../../Assets/Icons/search.png';
import Dropdown from '../../../../Components/Dropdown';
import GenerateProgressReportController from '../../../Controllers/AdminScreens/ProgressCard/GenerateProgressReportController';
import Loader from '../../../../Components/Loader';
import MonthYearCal from '../../../../Components/MonthYearInput';

const GenerateProgressReports = () => {
    const {
        reportName, handleReportName, statusError, startDateError, endDateError, monthYearError, handleMonthYearChange,
        status, setStatus, startDate, setStartDate, endDate, setEndDate, monthYear, 
        generateReportSuccess, generateReportError, generateReportLoading,
        handleSearchClient, clientListLoading, clientSearchError, clientList,
        clientError, handleSearchInputChange, handleSelectedClient,
        searchClient, generateReportValidation, resetFilter, reportNameError,
        reportNameOptions, roleTypesOptions, roleType, handleRoleTypeChange,
        shouldShowStatusDropdown, dropdownOptions, groupClient, setGroupClient,
        groupClientOptionsList, groupLoading, groupClientError, bulkTypesOptions,
        shouldShowClientSearch, reportTypesOptions, reportype, handleReportType,
        bulkType, setBulkType, handleSearchUser, userListLoading, userSearchError,
        userList, userError, handleUserInputChange, handleSelectedUser, searchUser,
        selectedRoleTypesOptions, selectedRoleType, setselectedRoleType, selectedRoleError,
        userLoading, bulkTypeError, selectedTeamId, setselectedTeamId, roleTypeError
    } = GenerateProgressReportController();



    const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
    const toggleDropdown = (dropdownName) => {
        setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
    };

    const dropdownRefs = useRef({}); // Ref for dropdown

    // Handle clicks outside dropdowns
    useEffect(() => {
        const handleClickOutside = (event) => {
            const isOutside = Object.keys(dropdownRefs.current).every(
                (key) =>
                    dropdownRefs.current[key] === null ||  // Ignore null values
                    (dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target))
            );
            if (isOutside) {
                setOpenDropdown(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setOpenDropdown(openDropdown);
    }, [openDropdown])

    return (
        <>
            <div style={{ width: '93%', margin: 'auto' }}>
                <h3 style={styles.header}>
                    <div style={styles.headerContainer}>
                        <span>Progress Card - Reports</span>
                    </div>
                </h3>
            </div>
            <div className="tasksScreen-main-content" style={{ width: 'unset' }}>
                <div className="tasksScreen-tasks-container" >
                    <div className="tasksScreen-tasks-header">
                        <h2 className="tasksScreen-tasks-title">Generate Reports</h2>
                    </div>
                    <hr className="footer-divider" />
                    <div style={{ width: '220px' }}>
                        <Dropdown
                            ref={(el) => (dropdownRefs.current["Report Name"] = el)}
                            isOpen={openDropdown === "Report Name"}
                            toggleDropdown={() => toggleDropdown("Report Name")}
                            label="Report Name"
                            options={reportNameOptions}
                            value={reportName}
                            onChange={handleReportName}
                            searchBoxWidth={200}
                            errorMessage={reportNameError}
                        />
                    </div>

                    {shouldShowClientSearch &&
                        <div className="filter-field" style={{ paddingBottom: '10px', marginTop: '10px', marginBottom: '5px', width: '300px' }}>
                            <label style={{ fontSize: '12px', color: '#343C44' }}>Client Name</label>
                            <TextInput
                                type="text"
                                placeholder="Client Name"
                                value={searchClient}
                                onChange={(e) => handleSearchInputChange(e.target.value)}
                                onRightClick={handleSearchClient}
                                // searchBoxWidth={280}
                                right={
                                    clientListLoading ? (
                                        <Loader loading={clientListLoading} color={'var(--primary-loader-color)'} size='small' /> // Show loader when loading
                                    ) : (
                                        <img src={search} alt="Search" style={{ cursor: 'pointer', height: '20px', width: '20px' }} />
                                    )
                                }
                                style={{ padding: '20px 10px' }}
                                errorMessage={clientError || clientSearchError}
                                isEdit={!groupClient}
                            />
                            {clientList?.length > 0 && (
                                <ul style={styles.dropdownList}>
                                    {clientList?.map((employee, index) => (
                                        <li
                                            key={employee?.client_id}
                                            onClick={() => handleSelectedClient(employee)}
                                            style={{
                                                ...styles.dropdownItem,
                                                borderBottom: index !== clientList?.length - 1 ? '1px solid #ccc' : 'none', // Add line below except last item
                                            }}
                                        >
                                            {employee?.client_name}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    }
                    {(reportName?.value === 'schedule_report' || reportName?.value === 'todo_report' || reportName?.value === 'user_login_report') &&
                        <div className="filter-field" style={{ paddingBottom: '10px', marginTop: '10px', marginBottom: '5px', width: '300px' }}>
                        <label style={{ fontSize: '12px', color: '#343C44' }}>User Name</label>
                        <TextInput
                            type="text"
                            placeholder="User Name"
                            value={searchUser}
                            onChange={(e) => handleUserInputChange(e.target.value)}
                            onRightClick={handleSearchUser}
                            // searchBoxWidth={280}
                            right={
                                userListLoading ? (
                                    <Loader loading={userListLoading} color={'var(--primary-loader-color)'} size='small' /> // Show loader when loading
                                ) : (
                                    <img src={search} alt="Search" style={{ cursor: 'pointer', height: '20px', width: '20px' }} />
                                )
                            }
                            style={{ padding: '20px 10px' }}
                            errorMessage={userError || userSearchError}
                            // isEdit={!groupClient}
                        />
                        {userList?.length > 0 && (
                            <ul style={styles.dropdownList}>
                                {userList?.map((employee, index) => (
                                    <li
                                        key={employee?.emp_id}
                                        onClick={() => handleSelectedUser(employee)}
                                        style={{
                                            ...styles.dropdownItem,
                                            borderBottom: index !== userList?.length - 1 ? '1px solid #ccc' : 'none', // Add line below except last item
                                        }}
                                    >
                                        {employee?.emp_name}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    
                    }
                    {(reportName?.value === 'export_task_comments_report' || reportName?.value === 'work_process_revenue_report') &&
                        <div style={{ maxWidth: '300px' }}>
                            <Dropdown
                                ref={(el) => (dropdownRefs.current["groupNameid"] = el)}
                                isOpen={openDropdown === "groupNameid"}
                                toggleDropdown={() => toggleDropdown("groupNameid")}
                                label="Group Name" options={groupClientOptionsList || []}
                                value={groupClient} onChange={setGroupClient} errorMessage={groupClientError}
                                loading={groupLoading} searchBoxWidth={280}
                                disabled={searchClient} />
                        </div>
                    }

                    {reportName?.value === 'user_activity_report' &&
                        <div style={{ paddingTop: 10, maxWidth: '300px' }}>
                            <Dropdown
                                ref={(el) => (dropdownRefs.current["reportType"] = el)}
                                isOpen={openDropdown === "reportType"}
                                toggleDropdown={() => toggleDropdown("reportType")}
                                label="Report Type:"
                                options={reportTypesOptions}
                                value={reportype}
                                onChange={handleReportType}
                                // isMulti
                                searchBoxWidth={280}
                                errorMessage={roleTypeError}
                            />
                        </div>
                    }
                    {reportName?.value === 'bulk_task_log_report' &&
                        <div style={{ paddingTop: 10, maxWidth: '300px' }}>
                            <Dropdown
                                ref={(el) => (dropdownRefs.current["bulkType"] = el)}
                                isOpen={openDropdown === "bulkType"}
                                toggleDropdown={() => toggleDropdown("bulkType")}
                                label="Type of Bulk Operation"
                                options={bulkTypesOptions}
                                value={bulkType}
                                onChange={setBulkType}
                                // isMulti
                                searchBoxWidth={280}
                                errorMessage={bulkTypeError}
                            />
                        </div>
                    }

                    {(reportName?.value === 'employee_report' || reportName?.value === 'consolidate_report') &&
                        <div style={{ paddingTop: 10, maxWidth: '300px' }}>
                            <Dropdown
                                ref={(el) => (dropdownRefs.current["Select list"] = el)}
                                isOpen={openDropdown === "Select list"}
                                toggleDropdown={() => toggleDropdown("Select list")}
                                label="Select Role"
                                options={roleTypesOptions}
                                value={roleType}
                                onChange={handleRoleTypeChange}
                                searchBoxWidth={280}
                            />
                        </div>
                    }


                    {(roleType?.value === 'user_wise' || reportype?.value === 'user_wise') &&

                        <div className="filter-field" style={{ paddingBottom: '10px', marginTop: '10px', marginBottom: '5px', width: '300px' }}>
                            <label style={{ fontSize: '12px', color: '#343C44' }}>User Name</label>
                            <TextInput
                                type="text"
                                placeholder="User Name"
                                value={searchUser}
                                onChange={(e) => handleUserInputChange(e.target.value)}
                                onRightClick={handleSearchUser}
                                // searchBoxWidth={280}
                                right={
                                    userListLoading ? (
                                        <Loader loading={userListLoading} color={'var(--primary-loader-color)'} size='small' /> // Show loader when loading
                                    ) : (
                                        <img src={search} alt="Search" style={{ cursor: 'pointer', height: '20px', width: '20px' }} />
                                    )
                                }
                                style={{ padding: '20px 10px' }}
                                errorMessage={userError || userSearchError}
                            />
                            {userList?.length > 0 && (
                                <ul style={styles.dropdownList}>
                                    {userList?.map((employee, index) => (
                                        <li
                                            key={employee?.emp_id}
                                            onClick={() => handleSelectedUser(employee)}
                                            style={{
                                                ...styles.dropdownItem,
                                                borderBottom: index !== userList?.length - 1 ? '1px solid #ccc' : 'none', // Add line below except last item
                                            }}
                                        >
                                            {employee?.emp_name}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>}

                    {/* Second Dropdown (Dynamic List Based on Role) */}
                    {(roleType?.value && roleType?.value !== 'user_wise') &&
                        <div style={{ paddingTop: 10, maxWidth: '300px' }}>
                            <Dropdown
                                ref={(el) => (dropdownRefs.current["Select role items"] = el)}
                                isOpen={openDropdown === "Select role items"}
                                toggleDropdown={() => toggleDropdown("Select role items")}
                                label={`Select ${roleType?.label || "Role"}`}
                                options={selectedRoleTypesOptions}
                                value={selectedRoleType}
                                onChange={setselectedRoleType}
                                isMulti={true}
                                searchBoxWidth={280}
                                loading={userLoading}
                                errorMessage={selectedRoleError}
                            />
                        </div>}

                    {/* Second Dropdown (Dynamic List Based on Role) */}
                    {reportype?.value === 'team_wise' &&
                        <div style={{ paddingTop: 10, maxWidth: '300px' }}>
                            <Dropdown
                                ref={(el) => (dropdownRefs.current["Select role items"] = el)}
                                isOpen={openDropdown === "Select role items"}
                                toggleDropdown={() => toggleDropdown("Select role items")}
                                label={`Select ${roleType?.label || "Role"}`}
                                options={selectedRoleTypesOptions}
                                value={selectedTeamId}
                                onChange={setselectedTeamId}
                                isMulti={false}
                                searchBoxWidth={280}
                                loading={userLoading}
                                errorMessage={selectedRoleError}
                            />
                        </div>}



                    {shouldShowStatusDropdown && (
                        <div style={{ marginBottom: '10px', marginTop: '10px', width: '220px' }}>
                            <Dropdown
                                ref={(el) => (dropdownRefs.current["Select Status"] = el)}
                                isOpen={openDropdown === "Select Status"}
                                toggleDropdown={() => toggleDropdown("Select Status")}
                                label="Select Status"
                                options={dropdownOptions}
                                value={status}
                                onChange={setStatus}
                                errorMessage={statusError}
                            />
                        </div>
                    )}

                    {reportName?.value !== 'employee_payout_report' && <div style={{ marginTop: '10px' }}>
                        <div className="filter-field">
                            <label>{reportName?.value === 'attendance_report' || reportName?.value === 'user_login_report' ? 'Month & Year' : 'Period'}</label>
                            {reportName?.value === 'attendance_report' || reportName?.value === 'user_login_report' ? 
                                <div style={{ width: 220 }}>
                                    <MonthYearCal
                                        value={monthYear || ""}
                                        onChange={(val) => handleMonthYearChange(val)}
                                        errorMessage={monthYearError}
                                        disableFuture={true}
                                    />
                                 </div>
                            :
                                <div style={{ display: 'flex', alignItems: 'flex-start',flexWrap:'wrap' }}>
                                {/* Start Date */}
                                <div style={{  }}>
                                    <DateInput
                                        value={startDate || ""}
                                        onChange={(e) => setStartDate(e.target.value)}
                                        errorMessage={startDateError}
                                        max={reportName?.value !== 'schedule_report' ? new Date().toLocaleDateString("en-CA") : undefined}
                                    />
                                </div>

                                {!(reportName?.value === 'consolidate_report' && status?.value === 2) && (
                                    <><div style={{ padding: '0 10px', lineHeight: '47px' }}>-</div>
                                    <div style={{  }}>
                                        <DateInput
                                            value={endDate || ""}
                                            onChange={(e) => setEndDate(e.target.value)}
                                            errorMessage={endDateError}
                                            max={reportName?.value !== 'schedule_report' ? new Date().toLocaleDateString("en-CA") : undefined}
                                        />
                                    </div>
                                    </>
                                )}
                                </div>
                            }
                        </div>
                    </div> }




                    <div className="button-container" style={{ gap: "10px" }}>
                        <button className="add-client-button" onClick={() => generateReportValidation()}
                            style={{
                                cursor: generateReportLoading ? "not-allowed" : "pointer",
                                opacity: generateReportLoading ? 0.6 : 1,
                                pointerEvents: generateReportLoading ? 'none' : 'auto',
                                gap: '5px',
                                display: 'flex'
                            }}
                            disabled={generateReportLoading}>

                            {generateReportLoading && (
                                <Loader loading={generateReportLoading} color={'var(--background-color)'} size="small" />
                            )}
                            <span>Generate</span>
                        </button>
                        <button style={styles.cancelButton} onClick={resetFilter}>
                            Cancel
                        </button>
                        {generateReportError && <div style={{ fontSize: '12px', color: 'red', display: 'flex', alignItems: 'center' }}>{generateReportError} </div>}
                        {generateReportSuccess && <div style={{ fontSize: '12px', color: 'green', display: 'flex', alignItems: 'center' }}>{generateReportSuccess} </div>}
                    </div>
                </div>
            </div>
            <div>
            </div>
        </>
    );
};

const styles = {
    header: {
        fontSize: "22px",
        color: "#060606",
        marginBottom: "10px",
        fontWeight: 500,
        // fontFamily: 'Montserrat',
        //   marginLeft:'20px'
    },
    headerContainer: {
        display: 'flex',
        alignItems: 'center', // Vertically align items
    },
    cancelButton: {
        display: "flex",
        alignItems: "center",
        backgroundColor: "white",
        color: "var(--button-bg-color)",
        border: "1px solid var(--button-bg-color)",
        padding: "8px 16px",
        borderRadius: '20px',
        cursor: "pointer",
    },
    dropdownList: {
        position: 'absolute',
        top: '85%',
        left: 0,
        right: 0,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderRadius: '4px',
        maxHeight: '200px',
        overflowY: 'auto',
        zIndex: 1000,
        padding: 0, // Remove default padding
        margin: 0, // Remove default margin
        listStyleType: 'none', // Remove the dots
    },

    dropdownItem: {
        padding: '10px',
        cursor: 'pointer',
        borderBottom: '1px solid #eee', // Default for all items
        backgroundColor: '#fff',
        hover: {
            backgroundColor: '#f0f0f0',
        },
    },
};

export default GenerateProgressReports;
